export function getPageScrollTop(): number {
  if (typeof document === "undefined") {
    return 0;
  }

  const body = document.body;
  const docEl = document.documentElement;

  /*
   * When scroll is locked via `body { position: fixed; top: -scrollYpx }`,
   * `documentElement.scrollTop` becomes 0 even though the page is effectively scrolled.
   */
  if (body?.style?.position === "fixed") {
    const top = body.style.top; // e.g. "-123px"
    const parsed = parseInt(top || "0", 10);
    if (!Number.isNaN(parsed)) {
      return Math.abs(parsed);
    }
  }

  return docEl?.scrollTop ?? window.scrollY ?? 0;
}
